import api from "../../api/api";

// export const getAllContents = async (data) => await api.post(`saveMasterStudActContents`, data);


export const savetrainingcontent_thunk = async (data) => await api.post(`saveMasterStudActContent`, data);


export const update_content_template_thunk = async (data) => await api.put(`updateMasterStudActContent`, data);
